/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommonData } from './commonData';
import { TasksV2SubTypesEnum } from './tasksV2SubTypesEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { TaskResourceType } from './taskResourceType';
import { TasksV2TypesEnum } from './tasksV2TypesEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { TaskStatesEnum } from './taskStatesEnum';


export interface TaskV2 { 
    id?: string;
    /**
     * Org id
     */
    org_id?: string;
    org_name?: string;
    org_type?: string;
    state?: TaskStatesEnum;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    type?: TasksV2TypesEnum;
    task_type_desc?: string;
    sub_type?: TasksV2SubTypesEnum;
    task_sub_type_desc?: string;
    resource_type?: TaskResourceType;
    resource_id?: string;
    /**
     * Time at which Task was QUEUED
     */
    start_time?: Date;
    /**
     * Time at which Task was completed (success or failure)
     */
    end_time?: Date;
    /**
     * User who triggered the associated task
     */
    created_by?: string;
    progress_percent?: number;
    data?: CommonData;
    /**
     * List of event IDs
     */
    events?: Array<string>;
    /**
     * List of sub-task IDs
     */
    'sub-tasks'?: Array<string>;
    task_spec?: object;
}
export namespace TaskV2 {
}


